import { render, staticRenderFns } from "./TagListPage.vue?vue&type=template&id=08a45a69&scoped=true&"
import script from "./TagListPage.vue?vue&type=script&lang=js&"
export * from "./TagListPage.vue?vue&type=script&lang=js&"
import style0 from "./TagListPage.vue?vue&type=style&index=0&id=08a45a69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a45a69",
  null
  
)

export default component.exports